import logoIAA from '../../assets/images/vica/logoIAA.png'
import logoVICA from '../../assets/images/vica/logoVICA.png'
import dpt from '../../assets/images/vica/dpt.jpg'
import dpz from '../../assets/images/vica/dpz.jpg'
import SearchComponent from '../sgvmap/SearchComponent'
import { Content } from 'antd/es/layout/layout'
import { Image, Space, Tooltip } from 'antd'
import { isMobile } from 'react-device-detect';

const VicaHeader = ({ }) => {

    function getHeaderStyle() {
        if (isMobile) {
            return {
                position: "absolute",
                top: "0px",
                left: "0px",
                zIndex: "10",
                height: "60px",
                padding: "0 5px",
                backgroundColor: "#446485",
                backgroundImage: "linear-gradient(to top, #446485 0%, #6788A2 100%)",
                borderRadius: "0px",
                padding: '0 5px',
            }
        }
        else {
            return {
                position: "absolute",
                top: "10pX",
                left: "10px",
                zIndex: "10",
                height: "60px",
                padding: "0 5px",
                backgroundColor: "#446485",
                backgroundImage: "linear-gradient(to top, #446485 0%, #6788A2 100%)",
                borderRadius: "25px",
                padding: '0 50px',
                maxWidth: "38%" 
            }
        }
    }


    let logosStyle = {
        height: "55px"
    }

    let logosMiniStyle = {
        height: "20px"
    }

    return (
        <Space direction="horizontal" style={{ ...getHeaderStyle()}}>
            <Tooltip title="Instituto Aragonés del Agua">
                <Image
                    style={logosStyle}
                    src={logoIAA}
                />
            </Tooltip>
            <Tooltip title="Visor de Infraestructuras del Ciclo del Agua (VICA)">
                <Image
                    style={logosStyle}
                    src={logoVICA}
                />
            </Tooltip>
            <Space direction="vertical" size="small">
                <Tooltip title="Diputación Provincial de Teruel">
                    <Image
                        style={logosMiniStyle}
                        src={dpt}
                    />
                </Tooltip>
                <Tooltip title="Diputación Provincial de Zaragoza">
                    <Image
                        style={logosMiniStyle}
                        src={dpz}
                    />
                </Tooltip>
            </Space>
            <Space direction="vertical">
                <SearchComponent
                    mapView={window.mapView}
                    placeholder={"Buscar municipio o EDAR"}
                    queries={[
                        {
                            queryUrl:"https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv/MapServer/23/query",
                            searchfields: ["D_MUNI_INE"],
                            resultsfields: ["D_MUNI_INE"],
                            mask:"Municipio: ${value}"
                        },
                        {
                            //queryUrl:"https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv/MapServer/18/query",
                            queryUrl:"https://idearagon.aragon.es/servicioslidar/rest/services/IAA/iaa_v4_sgv/MapServer/18/query",
                            searchfields: ["NOMBRE_EDA"],
                            resultsfields: ["NOMBRE_EDA"],
                            mask:"EDAR: ${value}"
                        }
                    ]}
                ></SearchComponent>
            </Space>
        </Space>
    )
}

export default VicaHeader;